import { Box, Button, Divider, HStack, Image, Text, useDisclosure, VStack } from "@chakra-ui/react";
import { LuImage, LuPhone } from "react-icons/lu";
import EmailPreviewModal from "./EmailPreviewModal";

// Preview Components
export const WhatsAppPreview = ({ header, body, footer, buttons, otpType, authAddExpirationTime, authCodeExpiryMinutes, templateType }) => (
    <Box p={4} borderWidth="1px" borderRadius="lg" bg="#e5ddd5" maxW="300px">

        <VStack align="stretch" spacing={3} bg={"white"} p={4} borderRadius={"lg"}>
            {header?.type === 'text' && header?.content && (
                <Text fontWeight="bold" fontSize="sm">{header.content}</Text>
            )}
            {header?.type === 'image' && header?.file && (
                <Box borderRadius="md" overflow="hidden">
                    <img src={header.file} alt="Header" style={{ width: '100%', height: 'auto' }} />
                </Box>
            )}
            {header?.type === 'video' && header?.file && (
                <Box borderRadius="md" overflow="hidden" bg="gray.800" p={4} textAlign="center">

                    {header.file ? <video controls>

                        <source src={header.file} />
                        Your browser does not support the video tag.
                    </video> : <>
                        <LuImage size={32} color="white" style={{ margin: '0 auto' }} />
                        <Text fontSize="xs" color="white" mt={2}>Video: {header.file}</Text>
                    </>}

                    {/* <video src={header.file}  /> */}

                </Box>
            )}
            {header?.type === 'document' && header?.file && (
                <Box borderWidth="1px" borderRadius="md" p={2} bg="white">
                    <Text fontSize="xs" fontWeight="bold">Document</Text>
                    <Text fontSize="xs" color="gray.600" noOfLines={1}>{header.file}</Text>
                </Box>
            )}
            <Text fontSize="sm" whiteSpace="pre-wrap">{body || 'Message body will appear here'}</Text>
            {(authAddExpirationTime && templateType === '1') && (
                <Text fontSize="xs" whiteSpace="pre-wrap" color={"grey"}>Expires in {authCodeExpiryMinutes} {authCodeExpiryMinutes > 1 ? 'minutes' : 'minute'}.</Text>
            )}
            {footer && <Text fontSize="xs" color="gray.600">{footer}</Text>}
            {buttons?.length > 0 && (
                <VStack spacing={1}>
                    {buttons.map((btn, idx) => (
                        <Button key={idx} size="sm" variant="outline" w="full" fontSize="xs">
                            {btn.name || 'Button'}
                        </Button>
                    ))}
                </VStack>
            )}
            {(otpType && templateType === '1') && (
                otpType === 'COPY_CODE' ? <> <Divider /> <Text align={"center"} color={"#01acfb"} cursor={"pointer"} fontSize="xs">
                    {otpType === 'COPY_CODE' ? 'Copy Code' : "Auto fill"}
                </Text> </> : otpType === 'ONE_TAP' ? <><Divider /><Text align={"center"} color={"#01acfb"} cursor={"pointer"} fontSize="xs">
                    {otpType === 'ONE_TAP' ? 'Auto Fill' : ""}
                </Text>
                </> : ""

            )}
        </VStack>
    </Box>
);

export const InAppPreview = ({ header, body, footer, buttons, otpType, isWhatsapp }) => (
    <Box p={4} borderRadius="lg" bg="#f6f3f4" maxW="300px">
        <VStack align="stretch" spacing={3} p={4} borderRadius={"lg"} bg={"white"} boxShadow={"md"}>
            {header?.type === 'text' && header?.content && (
                <Text fontWeight="bold" fontSize="sm">{header.content}</Text>
            )}
            {header?.type === 'image' && header?.file && (

                <Box borderRadius="md" overflow="hidden">
                    <img src={header.file} alt="Header" style={{ width: '100%', height: 'auto' }} />
                </Box>
            )}
            {header?.type === 'video' && header?.file && (
                // <Box borderRadius="md" overflow="hidden" bg="gray.800" p={4} textAlign="center">
                //     <LuImage size={32} color="white" style={{ margin: '0 auto' }} />
                //     <Text fontSize="xs" color="white" mt={2}>Video: {header.file}</Text>
                // </Box>
                <Box borderRadius="md" overflow="hidden" bg="gray.800" p={4} textAlign="center">

                    {header.file ? <video controls>

                        <source src={header.file} />
                        Your browser does not support the video tag.
                    </video> : <>
                        <LuImage size={32} color="white" style={{ margin: '0 auto' }} />
                        <Text fontSize="xs" color="white" mt={2}>Video: {header.file}</Text>
                    </>}

                    {/* <video src={header.file}  /> */}

                </Box>
            )}
            {header?.type === 'document' && header?.file && (
                <Box borderWidth="1px" borderRadius="md" p={2} bg="white">
                    <Text fontSize="xs" fontWeight="bold">Document</Text>
                    <Text fontSize="xs" color="gray.600" noOfLines={1}>{header.file}</Text>
                </Box>
            )}
            <Text fontSize="sm" whiteSpace="pre-wrap">{body || 'Message body will appear here'}</Text>
            {footer && <Text fontSize="xs" color="gray.600">{footer}</Text>}
            {buttons?.length > 0 && (
                <VStack spacing={1}>
                    {buttons.map((btn, idx) => (
                        <Button key={idx} size="sm" variant="outline" w="full" fontSize="xs">
                            {btn.name || 'Button'}
                        </Button>
                    ))}
                </VStack>
            )}
            {(otpType && isWhatsapp) && (
                otpType === 'COPY_CODE' ? <> <Divider /> <Text align={"center"} color={"#01acfb"} cursor={"pointer"} fontSize="xs">
                    {otpType === 'COPY_CODE' ? 'Copy Code' : ""}
                </Text> </> : <></>

            )}
        </VStack>
    </Box>
);

export const SMSPreview = ({ body = '' }) => {
    const chunkSize = 160;

    const chunks = body
        ? body.match(new RegExp(`.{1,${chunkSize}}`, 'g'))
        : ['SMS message will appear here'];


    return (
        <Box>
            <VStack
                p={4}
                borderWidth="1px"
                borderRadius="lg"
                bg="blue.50"
                maxW="300px"
                mb={3}
                gap={3}
                align="stretch"
            >
                <Box

                    bg="white"
                    p={3}
                    borderRadius="md"
                    boxShadow="sm"
                >
                    <Text fontSize="xs" color="gray.600" mb={2}>
                        SMS Message
                    </Text>

                    <Text fontSize="sm" whiteSpace="pre-wrap">
                        {body || 'SMS message will appear here'}
                    </Text>
                </Box>
            </VStack>
        </Box>
    );
};



export const PushPreview = ({ title, body, imageUrl }) => (
    <Box p={4} borderWidth="1px" borderRadius="lg" bg="orange.50" maxW="300px">
        <Box bg="white" p={3} borderRadius="md" boxShadow="md">
            <HStack spacing={2} mb={2} alignItems="flex-start">
                {imageUrl ? (
                    <Box
                        w={8}
                        h={8}
                        bg="#eeeff0ff"
                        borderRadius="md"
                        flexShrink={0}
                        p={1}
                        display="flex"
                        alignItems="center"
                        justifyContent="center"
                    >
                        <Image
                            src={imageUrl}
                            maxW="100%"
                            maxH="100%"
                            objectFit="contain"
                        />
                    </Box>
                ) : (
                    <Box
                        w={8}
                        h={8}
                        bg="#eeeff0ff"
                        borderRadius="md"
                        flexShrink={0}
                    />
                )}


                <Box flex={1}>
                    <Text fontWeight="bold" fontSize="sm" noOfLines={1}>
                        {title || 'Notification Title'}
                    </Text>
                    <Text fontSize="xs" color="gray.600" noOfLines={2}>
                        {body || 'Notification body'}
                    </Text>
                </Box>
            </HStack>
            {/* {imageUrl && (
                <Box mt={2} borderRadius="md" overflow="hidden">
                    <img src={imageUrl} alt="Notification" style={{ width: '100%', height: 'auto' }} />
                </Box>
            )} */}
        </Box>
    </Box>
);

export const EmailPreview = ({ subject, body, emailType }) => {
    const { isOpen: isEmailPreviewOpen, onOpen: onEmailPreviewOpen, onClose: onEmailPreviewClose } = useDisclosure();
    return (
        <Box p={4} borderWidth="1px" borderRadius="lg" bg="red.50" maxW="300px">
            <Box bg="white" p={3} borderRadius="md" boxShadow="sm">
                <Text fontSize={"sm"} fontWeight={"600"}>Subject:</Text>
                <Text fontSize="sm" mb={3}>
                    {subject || 'Email Subject'}
                </Text>
                <Text fontSize={"sm"} fontWeight={"600"}>Body:</Text>
                {emailType === 'html' ? (
                    <Text fontSize="xs" cursor={"pointer"} onClick={onEmailPreviewOpen} color={"#2563eb"}>
                        Preview HTML Content
                    </Text>
                ) : <Text fontSize="xs" noOfLines={4}>
                    {body || 'Email body content'}
                </Text>}

            </Box>
            <EmailPreviewModal subject={subject} body={body} onEmailPreviewClose={onEmailPreviewClose} isEmailPreviewOpen={isEmailPreviewOpen} />
        </Box>
    )
};

export const VoicePreview = ({ script }) => (
    <Box p={4} borderWidth="1px" borderRadius="lg" bg="purple.50" maxW="300px">
        <VStack align="stretch" spacing={3}>
            <HStack spacing={2}>
                <LuPhone />
                <Text fontWeight="bold" fontSize="sm">Voice Call</Text>
            </HStack>
            <Box bg="white" p={3} borderRadius="md">
                <Text fontSize="xs" whiteSpace="pre-wrap">
                    {script || 'Voice script will appear here'}
                </Text>
            </Box>
        </VStack>
    </Box>
);